module.exports = __webpack_public_path__ + "img/Rich_Morris@1x.7b3f0ed9.png";